import { render } from "./AddDefaultMessage.vue?vue&type=template&id=252b6d16&scoped=true"
import script from "./AddDefaultMessage.vue?vue&type=script&lang=js"
export * from "./AddDefaultMessage.vue?vue&type=script&lang=js"

import "./AddDefaultMessage.vue?vue&type=style&index=0&id=252b6d16&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252b6d16"]])

export default __exports__